export const USER_FORM = 'userForm';
export const USER_FIRST_NAME_FIELD = 'firstName';
export const USER_LAST_NAME_FIELD = 'lastName';
export const USER_EMAIL_FIELD = 'email';
export const USER_CONFIRM_EMAIL_FIELD = 'confirmEmail';
export const USER_PHONE_FIELD = 'phone';
export const USER_PASSWORD_FIELD = 'password';
export const USER_AGREE_TERMS_FIELD = 'agreeTerms';

export const USER_INITIAL_STATE = {
    [USER_FIRST_NAME_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_LAST_NAME_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_EMAIL_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_CONFIRM_EMAIL_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_PHONE_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_PASSWORD_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [USER_AGREE_TERMS_FIELD]: {
        value: false,
        isValid: true,
        errorMessage: null,
    },
};
